export const FanzineSportsActionTypes = {
	SET_IS_LOGIN: "SET_IS_LOGIN",
}
